import { render, staticRenderFns } from "./demand-module.vue?vue&type=template&id=5c3f01d8&scoped=true&"
import script from "./demand-module.vue?vue&type=script&lang=js&"
export * from "./demand-module.vue?vue&type=script&lang=js&"
import style0 from "./demand-module.vue?vue&type=style&index=0&id=5c3f01d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f01d8",
  null
  
)

export default component.exports